import { Link } from 'react-router-dom';

interface LogoProps {
  compact?: boolean;
}

export default function Logo({ compact = false }: LogoProps) {
  return (
    <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="鲁啊鲁首页">
      <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
        鲁
      </span>
      {compact ? null : (
        <span className="flex flex-col leading-none">
          <span className="font-heading text-lg font-bold text-foreground-950">鲁啊鲁</span>
          <span className="text-[10px] tracking-wide text-foreground-400">LUALU MEDIA</span>
        </span>
      )}
    </Link>
  );
}